const roles = {
    SUPERUSER: 'SUPERUSER',
    BUSINESS_ADMIN: 'BUSINESS_ADMIN',
    GUEST: 'GUEST'
}

export default roles